import { render, staticRenderFns } from "./ESituacaoMatricula.vue?vue&type=template&id=5fe316eb"
import script from "./ESituacaoMatricula.vue?vue&type=script&lang=js"
export * from "./ESituacaoMatricula.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports